/**
 * About Euhomy 2 — Year Milestone
 * 年份切换 + 指示器滑动 + 图文淡入
 */
(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 769px)';
  var MOBILE_MQ = '(max-width: 768px)';
  var EASE = 'power2.out';

  function q(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function qa(root, sel) {
    return root ? Array.from(root.querySelectorAll(sel)) : [];
  }

  function centerIn(el, container) {
    var elRect = el.getBoundingClientRect();
    var boxRect = container.getBoundingClientRect();
    return elRect.left + elRect.width * 0.5 - boxRect.left;
  }

  function initOne(root, gsap) {
    var yearsDesk = qa(root, '[data-ae2-ms-year]');
    var yearsMob = qa(root, '[data-ae2-ms-year-mob]');
    var panels = qa(root, '[data-ae2-ms-panel]');
    var indicatorDesk = q(root, '[data-ae2-ms-indicator-desk]');
    var trackDesk = q(root, '[data-ae2-ms-track-desk]');
    var indicatorMob = q(root, '[data-ae2-ms-indicator-mob]');
    var yearsMobWrap = q(root, '[data-ae2-ms-years-mob]');

    if (!panels.length) return function () {};

    var index = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function moveDeskIndicator(i, immediate) {
      if (!yearsDesk[i] || !indicatorDesk || !trackDesk) return;
      var xTrack = centerIn(yearsDesk[i], trackDesk);
      if (!Number.isFinite(xTrack)) return;
      if (immediate || reduced || !gsap) {
        if (gsap) gsap.set(indicatorDesk, { x: xTrack });
        else indicatorDesk.style.transform = 'translateX(' + xTrack + 'px)';
      } else {
        gsap.to(indicatorDesk, { x: xTrack, duration: 0.42, ease: EASE, overwrite: true });
      }
    }

    function moveMobIndicator(i, immediate) {
      if (!indicatorMob || !yearsMob[i] || !yearsMobWrap) return;
      var btn = yearsMob[i];
      var top = yearsMobWrap.offsetTop + btn.offsetTop + btn.offsetHeight * 0.5;
      if (immediate || reduced || !gsap) {
        if (gsap) gsap.set(indicatorMob, { top: top });
        else indicatorMob.style.top = top + 'px';
        return;
      }
      gsap.to(indicatorMob, {
        top: top,
        duration: 0.38,
        ease: EASE,
        overwrite: true,
      });
    }

    function showPanel(i) {
      panels.forEach(function (panel, pi) {
        var active = pi === i;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
        if (!active || reduced || !gsap) {
          panel.style.opacity = active ? '1' : '';
          panel.style.transform = '';
          return;
        }
        if (active) {
          gsap.fromTo(panel, { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.36, ease: EASE, overwrite: true });
        }
      });
    }

    function setActive(i, options) {
      options = options || {};
      var next = Math.max(0, Math.min(panels.length - 1, i));
      var isSame = next === index && root.dataset.activeIndex === String(next);
      if (isSame && !options.force) return;

      index = next;
      root.dataset.activeIndex = String(index);

      yearsDesk.forEach(function (btn, bi) {
        var on = bi === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      yearsMob.forEach(function (btn, bi) {
        var on = bi === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      showPanel(index);
      moveDeskIndicator(index, options.immediate);
      moveMobIndicator(index, options.immediate);
    }

    function onYearClick(ev) {
      var btn = ev.currentTarget;
      var i = parseInt(btn.getAttribute('data-index') || '0', 10);
      setActive(i);
    }

    yearsDesk.forEach(function (btn) {
      btn.addEventListener('click', onYearClick);
    });
    yearsMob.forEach(function (btn) {
      btn.addEventListener('click', onYearClick);
    });

    function onResize() {
      moveDeskIndicator(index, true);
      moveMobIndicator(index, true);
    }

    window.addEventListener('resize', onResize, { passive: true });

    function initLayout() {
      setActive(0, { force: true, immediate: true });
    }

    requestAnimationFrame(function () {
      initLayout();
      requestAnimationFrame(initLayout);
    });

    return function () {
      window.removeEventListener('resize', onResize);
      yearsDesk.forEach(function (btn) {
        btn.removeEventListener('click', onYearClick);
      });
      yearsMob.forEach(function (btn) {
        btn.removeEventListener('click', onYearClick);
      });
    };
  }

  function init(ctx) {
    var roots = qa(document, '[data-ae2-milestone]');
    if (!roots.length) return;

    var gsap = ctx && ctx.gsap ? ctx.gsap : window.gsap;
    var cleanups = roots.map(function (root) {
      return initOne(root, gsap);
    });

    return function () {
      cleanups.forEach(function (fn) {
        if (fn) fn();
      });
    };
  }

  if (window.AboutEuhomy2 && typeof window.AboutEuhomy2.register === 'function') {
    window.AboutEuhomy2.register(init);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init({ gsap: window.gsap });
    });
  } else {
    init({ gsap: window.gsap });
  }
})();
